export default {
  setPartners(state, p) {
    state.partners = p;
  }
}